"use strict";

App.Pages.StatStella = class StatStella extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/stat-stella',
			nameRu: 'Статистика по стеле',
		};
	}

	static get template()
	{
		//language=HTML
		return `
			<div class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<a href="#" onclick="history.back();" class="breadcrumb link"><i class="icon material-icons">chevron_left</i>Вернуться назад</a>
						<h3 pf="stellaName"></h3>
					</div>

					<form class="filterForm" pf="form">
						<div class="row resizable">
							<div class="col-65">
								<div pf="preset"></div>
							</div>
							<div class="col-15">
								<input pf="dates"/>
							</div>
							<div class="col-20">
								<div pf="discrete"></div>
							</div>
						</div>
					</form>
					<div class="row resizable" pf="plots">
						<div class="col-70">
							<div class="card" pf="chartBlock">
							</div>
						</div>
						<div class="col-30">
							<div class="card" pf="chartBlockEmotion"></div>
							<div class="card" style="margin-top: 16px;">
								<h4>Среднее время просмотра экрана</h4>
								<div class="clock" style="padding-left:16px;padding-top:8px;">
									<div class="part">
										<div class="digit2">
											<div class="digit" pf="m1">0</div>
											<div class="digit" pf="m2">0</div>
										</div>
										<div>минут</div>
									</div>
									<div class="colon">:</div>
									<div class="part">
										<div class="digit2">
											<div class="digit" pf="s1">0</div>
											<div class="digit" pf="s2">0</div>
											<div class="digit" style="text-align: center;">.</div>
											<div class="digit" pf="ms1">0</div>
											<div class="digit" pf="ms2">0</div>
											<div class="digit" pf="ms3">0</div>
										</div>
										<div>секунд</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
						<div class="preloader" style="margin:40px auto; ">
							<span class="preloader-inner">
								<span class="preloader-inner-gap"></span>
								<span class="preloader-inner-left">
									<span class="preloader-inner-half-circle"></span>
								</span>
								<span class="preloader-inner-right">
									<span class="preloader-inner-half-circle"></span>
								</span>
							</span>
						</div>
					</div>
				</div>

			</div>
		`;
	}

	init()
	{
		super.init();
		this.loadStatus = true;
		this.errorStatus = false;

		this.bindDom({ preloader: 'show' }, 'loadStatus');
		this.bindDom({ plots: 'show' }, ['loadStatus', 'errorStatus'], (l, e) => !l && !e);

		this.id = app.pageParams.id;

		this.stella = new PF.Model({
			represent: "stella/ViewOne",
			saveOnModify: false,
			where: `id ='${this.id}'`
		});

		this.stella.onValue('options.loadStatus', 'loaded', () =>
		{
			this.dom.stellaName.bindHtml();

			this.dom.stellaName.html = 'Статистика по стеле "' + this.stella.name + '"';
			this.statFilters = new PF.Model({ represent: "user-data/stat-stellas", saveOnModify: true, raw: { data: {} } });

			this.statFilters.onValue('options.loadStatus', 'loaded', () =>
			{
				this.statId = this.statFilters.data.get('stella.id');
				if (this.id !== this.statId)
				{
					this.statFilters.setData('data.stella', this.stella.toJSON(), true);
					this.statFilters.once('save-success', () => this.loadForm());
					this.statFilters.save();
				}
				else
				{
					this.loadForm();
				}
			}, true);
		});

		this.chekPoint = 0;

	}

	loadForm()
	{
		this.form = new PF.Form({
			dom: { element: this.dom.form },
			model: this.statFilters,
			keyPrefix: 'data.',
			toastOnSave: false,
			fieldsConfig: {
				dateDiapason: {
					class: PF.Field.DateDiapasonWithPreset,

					presetConfig: {
						dom: {
							element: this.dom.preset
						},
						key: 'data.diapasonPreset',
					},
					datesConfig: {

						dom: {
							element: this.dom.dates
						},
						startKey: 'data.calendar.start',
						finishKey: 'data.calendar.finish',
					},
				},
				discrete: {
					class: PF.Field.Select,
					label: 'Детализация по:',
					// class: PF.Field.ButtonsToggle,
					radioConfig: {
						listConfig: {
							modelsConfig: {
								raw: [
									{
										id: 'hour',
										name: "Часам"
									},
									{
										id: 'day',
										name: "Суткам"
									},
									{
										id: 'week',
										name: "Неделям"
									},
									{
										id: 'month',
										name: "Месяцам"
									},
								]
							}
						},
					},
				}
			}
		});

		this.statFilters.onChange('data.diapasonPreset', () =>
		{
			if (typeof this.statFilters.get('data.diapasonPreset' + '.discrete') === 'function')
			{
				let discrete = this.statFilters.get('data.diapasonPreset' + '.discrete')();
				if (this.statFilters.get('data.discrete.id') != discrete.id)
				{
					this.statFilters.setData('data.discrete', discrete, true);
					this.statFilters.trigger('changed');
					// console.log(this.statFilters.data.discrete);
				}
			}
		}, true);

		this.statFilters.on('save-success', () =>
		{
			this.loadPlots();
		}, true);
		this.dom.m1.bindText();
		this.dom.m2.bindText();
		this.dom.s1.bindText();
		this.dom.s2.bindText();
		this.dom.ms1.bindText();
		this.dom.ms2.bindText();
		this.dom.ms3.bindText();
	}

	loadPlots()
	{
		this.loadStatus = true;
		try
		{
			if (
				(this.statFilters.get('data.diapasonPreset', null, null) !== null || this.statFilters.get('data.calendar', null, null) !== null) &&
				this.statFilters.get('data.discrete', null, null) !== null)
			{

				app.toast("Запрос данных...");
				this.dom.chartBlock.empty();
				this.dom.chartBlockEmotion.empty();
				app.request('/demo/plot/stat-stella', [], (response) =>
				{
					app.toast("Ответ получен.");
					this.loadStatus = false;
					this.response = Util.isJsonString(response) ? JSON.parse(response) : response;
					this.chekPoint = 0;
					if (this.response.status != 'FAIL')
					{
						this.errorStatus = false;
						this.creatCharts();
						this.creatChartsEmotions();
						// this.dom.chartTime.text = this.response.data.avgViewTimeByStella;

						this.displayChartTime(this.response.data.avgViewTimeByStella);
					}
					else
					{
						app.toast("Нет данных.");
						this.errorStatus = true;
					}
				});

			}
		}
		catch (e)
		{
			console.log("loadPlots error");
			this.errorStatus = true;
		}
	}

	displayChartTime(timeStr)
	{
		let m1 = 0, m2 = 0, s1 = 0, s2 = 0, ms1 = 0, ms2 = 0, ms3 = 0;
		if (timeStr !== null)
		{
			let dur = Duration.fromISOTime(timeStr);
			let m = dur.minutes;
			m1 = m < 10 ? 0 : Math.floor(m / 10);
			m2 = m % 10;
			let s = dur.seconds;
			s1 = s < 10 ? 0 : Math.floor(s / 10);
			s2 = s % 10;
			let ms = dur.milliseconds;
			if (ms > 100)
			{
				ms1 = Math.floor(ms / 100);
				ms = ms - ms1 * 100;
				ms2 = Math.floor(ms / 10);
				ms3 = ms % 10;
			} else
			{
				ms1 = 0;
				ms2 = ms < 10 ? 0 : Math.floor(ms / 10);
				ms3 = ms % 10;
			}
		}
		this.dom.m1.text = m1;
		this.dom.m2.text = m2;
		this.dom.s1.text = s1;
		this.dom.s2.text = s2;
		this.dom.ms1.text = ms1;
		this.dom.ms2.text = ms2;
		this.dom.ms3.text = ms3;
	}


	creatChartsEmotions()
	{
		let option = {
			chart: {
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie'
			},
			tooltip: {
				pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
			},
			accessibility: {
				point: {
					valueSuffix: '%'
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: true,
						format: '{point.percentage:.1f} %'
					},
					showInLegend: true
				}
			}
		};

		this.emotion1 = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlockEmotion },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4>Соотношение эмоций за период</h4>`,//this.response.data.diapason.start + " по " + this.response.data.diapason.finish
				align: 'left',
			},
			series: [this.response.data.avgEmotionByStella.emotions.series],
			...option
		});
	}

	creatCharts()
	{
		let title = '';
		if (this.statFilters.data.calendar.start === this.statFilters.data.calendar.finish) {
			title = `за ${Util.toLocalDate(this.statFilters.data.calendar.start)} `;
		} else {
			title = `за период с ${Util.toLocalDate(this.statFilters.data.calendar.start)} по ${Util.toLocalDate(this.statFilters.data.calendar.finish)}`;
		}
		this.chartBlock = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlock },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4 class="plot">Количество детекций ${title}</h4>`,//this.response.data.diapason.start + " по " + this.response.data.diapason.finish
				align: 'left',
			},
			chart: {
				height: 516,
			},
			xAxis: {
				categories: this.response.data.countDetectionByStella.x,
				labels: { format: '{value}' }
			},
			yAxis: {
				title: { text: 'Кол-во детекций' }
			},
			series: this.response.data.countDetectionByStella.series,
			plotOptions: {
				column: {
					stacking: 'normal',
					dataLabels: {
						enabled: true
					}
				},
				area: {
					pointStart: 1940,
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},
		});
	}

};